<template>
      <v-container fill-height fluid>
        <v-row align-center justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-6">
              <v-toolbar color="green" dark flat>
                <v-toolbar-title>داشبورد</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field color="green" v-model="auth.email" label="نام کاربری" name="login" prepend-icon="mdi-account"
                                type="text"></v-text-field>

                  <v-text-field color="green" v-model="auth.pass" id="password" label="رمز عبور" name="password" prepend-icon="mdi-lock"
                                type="password"></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :loading="loading" color="green" @click="login" dark>ورود</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
</template>

<script>
export default {
  name: 'Login',
  data: () => ({
    auth: {
      email: '', // 'Abolhassanpirayeh@gmail.com',
      pass: '' // 'a10468Vp1485'
    },
    loading: false
  }),
  mounted () {
  },
  methods: {
    login () {
      this.loading = true
      const url = `${this.$store.state.api.base_url}${this.$store.state.api.login}`

      this.$store.dispatch('login', {
        data: {
          email: this.auth.email,
          password: this.auth.pass
        },
        url: url
      }).then(resp => {
        this.$store.dispatch('setToken', { access_token: resp.data.access_token })
        this.$store.commit('saveUserProfile', { user: resp.data.user })
        this.loading = false
      }).catch(err => {
        console.log('failed login! ', err)
        this.$store.state.authenticated = false
        this.loading = false
      })
    }
  }
}
</script>
